import { render, staticRenderFns } from "./link-email-account-form.vue?vue&type=template&id=0a12f6d8"
import script from "./link-email-account-form.vue?vue&type=script&lang=js"
export * from "./link-email-account-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports